// error reporting
// eslint-disable-next-line import/prefer-default-export
export const reportError = (error, info) => {
  // eslint-disable-next-line
  console.log(error, 'Additional information: ', info);
};
